import { Button, Grid, TextField } from "@material-ui/core";
import {
  createStyles, makeStyles,
  Theme
} from "@material-ui/core/styles";
import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import { useEffect } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
  getProjects,
  getProjectSampleAllData,
  UploadLibrary,
  uploadMediaFiles,
  updateProject,
  uploadReport,
} from "../../store/actions";
import ExportSample from "./ExportLabrary";
import Api from "../../../../helpers/api";
interface Props {
  getProjects: any;
  loading: any;
  projects: any;
  getProjectSampleAllData: any;
  sampleAllData: any;
  UploadLibrary: any;
  uploadMediaFiles: any;
  mediaUpload: any;
  updateProject: any;
  uploadReport: any;
}
const StopsPlace: React.FC<Props> = ({
  loading,
  getProjects,
  projects,
  getProjectSampleAllData,
  sampleAllData,
  UploadLibrary,
  uploadReport,

}) => {
  const [project, setProject] = React.useState<any>("");
  const [projectSampleData, setProjectSampleData] = useState<any>();
  const [file, setFile] = React.useState<any>("");
  const [clearIt, setClearIt] = useState<number>(1);
  const timer = useRef<any>(0);



  const uploadStorageFile = async (e: any) => {
    e.preventDefault();
    let formData = new FormData();
    formData.append("file", file);
    await UploadLibrary(formData);
    setFile("");
    setClearIt(clearIt === 1 ? 2 : 1);
    getProjects();

  };
  useEffect(() => {
    getProjects();

  }, []);
  const handleExport = () => {
    if (project) {
      Api.get("/genomics/project-samples", { project: project?._id, qcStatus: 'Pass', limit: 2500 }).then((data: any) => {
        setProjectSampleData(data);
      });
    }
  };

  return (
    <Grid container spacing={2} style={{ marginTop: 10 }}>
      <Grid container xs={12}>
        <h2 style={{ fontWeight: "bold", paddingTop: "20px", paddingBottom: "10px", textAlign: "center" }}>Library Export Data</h2>
        <form onSubmit={uploadStorageFile} style={{ width: "100%" }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <Autocomplete
                id="Project"
                onChange={(event, newValue) => {
                  setProject(newValue);
                  setProjectSampleData(null);
                }}
                options={projects?.results || []}
                blurOnSelect
                getOptionLabel={(option: any) => {
                  return (
                    (option?.projectId) +
                    " " +
                    (option?.institute?.name || "") +
                    " " +
                    (option?.scientist?.name || "") +
                    "," +
                    (option?.dealer?.firmName || "")
                  );
                }}
                onInputChange={(event, newInputValue) => {
                  let data = newInputValue.split(" ");
                  clearTimeout(timer.current);
                  timer.current = setTimeout(() => {
                    if (data.length > 0) {
                      getProjects(`?projectId=${data[0]}`);
                    }
                  }, 1000);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="input"
                    label="Project ID"
                    placeholder="Search ID/Client/Dealer Name"
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Button
                style={{ backgroundColor: "#14a37f", color: "white" }}
                variant="contained"
                fullWidth
                onClick={handleExport}
                disabled={project === ""}
              >
                Export
              </Button>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <input
                key={clearIt}
                type="file"
                onChange={(e: any) => setFile(e.target.files[0])}
                accept=".csv"
              />
              <sub><h6>*Upload .csv</h6></sub>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Button
                style={{ backgroundColor: "#9c27b0", color: "white" }}
                variant="contained"
                fullWidth
                onClick={uploadStorageFile}
                disabled={file === ""}
              >
                Upload
              </Button>
            </Grid>
          </Grid>
        </form>
        {/* <div>
          {reset && uploadRatelistData?.error !== undefined
            ? JSON.stringify(uploadRatelistData.error).replace(
              /"|{|}|[|]/g,
              ""
            )
            : ""}
        </div> */}
        <ExportSample rateListExport={projectSampleData} loading={loading} />
      </Grid>
    </Grid>
  );
};
const mapStateToProps = (state: any) => ({
  projects: state.GenomicsLabReducer.projects,
  sampleAllData: state.GenomicsLabReducer.sampleAllData,
  mediaUpload: state.GenomicsLabReducer.mediaUpload,
});
export default connect(mapStateToProps, {
  getProjects,
  getProjectSampleAllData,
  UploadLibrary,
  uploadMediaFiles,
  updateProject,
  uploadReport,

})(StopsPlace);
